module.exports = __webpack_public_path__ + "static/img/microLesson.f4b30542.png";